<template>
  <el-input v-model="text" placeholder="输入快速问答问题"/>
</template>

<script>
export default {
  name: "ai_qa_form_item",
  props: {
    item: Object
  },
  computed: {
    text: {
      get() {
        const suggests = this.item.suggests || [];
        return [this.item.text, ...suggests].join('|')
      },
      set(val) {
        const parts = val.split('|');
        this.item.text = parts[0];
        this.item.suggests = parts.slice(1);
      }
    }
  }
}
</script>
